import React, { useContext } from 'react';
import { Modal } from '@fluentui/react'
import { CUSTOM_STYLES } from '../../constants/Constants';
import themeContext from '../../context/theme/ThemeContext';

const ModalMain = (props) => {

  const isViewer = false;
  const Containerstyles=  {
    root:{
      backgroundColor: 'rgba(0, 0, 0, 0.75);',
   },
    main:{
      boxSizing: "border-box",
      borderRadius: "10px 10px 10px 10px",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
      border: CUSTOM_STYLES.MODAL_BORDER,
      width:props.modalDetails.width,
      minHeight: '150px',
      ...(props.modalDetails.height && { height: props.modalDetails.height }),
      ...(props.modalDetails.maxHeight && { maxHeight: props.modalDetails.maxHeight }),
      ...(props.modalDetails.maxWidth && { maxWidth: props.modalDetails.maxWidth }),
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    scrollableContent: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
  }

  const {getThemeColor} = useContext(themeContext)
  
  return (
    <div>
      <Modal styles={props.styles != undefined? props.styles:Containerstyles}
      className='main'
        titleAriaId="id"
        isOpen={props.showModal}
        allowTouchBodyScroll={true}
        // Optional passthrough to the underlying Fluent Layer. Fluent's Layer defaults to
        // eventBubblingEnabled=false, which stops mouse/touch events from bubbling to `document`.
        // Modals that host @dnd-kit drag-and-drop must set { eventBubblingEnabled: true } here so the
        // MouseSensor/TouchSensor (which listen on document) receive move/up events. See CustomEditor
        // captured-images modal.
        layerProps={props.layerProps}
      >
        {props.modalDetails.header}
        <div className='modal-body' style={{background: !isViewer ? getThemeColor("modal-body") : "#191919", color:getThemeColor("primary-color"), flex: 1, overflow: props.scrollableBody ? 'auto' : 'hidden'}}>{props.modalDetails.body}</div>
        {props.modalDetails.footer}
      </Modal>
    </div>
  )
}

export default ModalMain